<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_ca9" :custom="{storage: true}" export :refresh="{query: findList}">
      <template v-slot:buttons>
        <el-button v-if="userOilLog_search_button" @click="findList">
          查询
        </el-button>
        <el-button v-if="userOilLog_latest_button" :disabled="updateDisabled" type="primary" @click="getLatestData">拉取最新数据</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      row-id="id"
      height="80%"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="malId" title="记录ID" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.malId" placeholder="请输入记录ID" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="companyName" title="企业名称" min-width="300" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.companyName" placeholder="请输入企业名称" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="money" title="储值金额(元)" min-width="200" sortable>
          <template v-slot="{row}">
            {{ row.money+'' }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.moneyMin" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.moneyMax" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="type" title="储值类型" min-width="300" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.type" placeholder="请输入储值类型" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" min-width="320" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.createTimeRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { getMaLog, updateMaLog } from '@/api/userOil'
export default {
  data() {
    return {
      updateDisabled: false,
      loading: false,
      userOilLog_search_button: false, //查询
      userOilLog_latest_button: false, //拉取最新
      tableData: [],
      moneyArr: [],
      listQuery: {
        createTimeRange: '',
        createTimeStart: '',
        createTimeEnd: '',
        moneyMax:'',
        moneyMin:'',
        pageNum: 1,
        pageSize: 20,
        sortField: '',
        sortType: '',
        total: 0
      },
      Pagingconf: [],
      branchCode: this.$store.state.user.party.branchCode,
      userTypeOptions: [
        { value: '1', label: '储值账户' },
        { value: '2', label: '信用卡账户' },
        { value: '3', label: '入账账户' },
        { value: '4', label: '返点账户' },
        { value: '5', label: '体验金账户' }
      ],
      typeOptions: [
        { value: '1', label: '正常储值' },
        { value: '7', label: '转账转出' },
        { value: '15', label: '返点储值' },
        { value: '14', label: '转账储值' },
      ],
    }
  },
  created() {
    this.findList()
    this.userOilLog_search_button = this.getLimit('userOilLog_search_button')
    this.userOilLog_latest_button = this.getLimit('userOilLog_latest_button')
  },
  methods: {
    findList() {
      this.loading = true
      return new Promise((resolve) => {
        getMaLog(this.listQuery)
          .then((response) => {
            this.tableData = response.data.records
            this.listQuery.total = response.data.total
            response.data.total > 10000
              ? (this.Pagingconf = [20, 30, 50, 100, 10000])
              : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1])
            this.sumObject = response.data.sumObject
            resolve()
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1
      this.findList()
    },
    // 排序
    sortList({ column, property, order }) {
      if (order) {
        this.listQuery.sortField = property
        this.listQuery.sortType = order
      } else {
        this.listQuery.sortField = ''
      }
      this.findList()
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage
      this.listQuery.pageSize = pageSize
      this.findList()
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return '合计'
          }
          if (['amount', 'auditAmount'].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property)
          }
          return null
        })
      ]
    },
    // 时间选择
    changeDate(value) {
      if (value) {
        this.listQuery.createTimeStart = value[0] + ' 00:00:00'
        this.listQuery.createTimeEnd = value[1] + ' 23:59:59'
      } else {
        this.listQuery.createTimeStart = ''
        this.listQuery.createTimeEnd = ''
      }
    },
    getLatestData() {
      this.updateDisabled = true
      updateMaLog()
        .then((response) => {
          this.findList()
        })
        .finally(() => {
          this.updateDisabled = false
        })
    }
  }
}
</script>
